module.exports = __webpack_public_path__ + "static/sommer-03-cac449fa2ee9e51479fa63b852f8f212.jpg";